module.exports = __webpack_public_path__ + "static/img/egg_g_09.ca0f96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_09.png
// module id = ghx+
// module chunks = 1